import { Fragment } from 'react';
import Header from './Header';
import NoiseCanvas from './NoiseCanvas';
import InfoPanel from './InfoPanel';
import { TEXTURE_LINES } from '../data/products';
import styles from './Hero.module.css';

export default function Hero({ onOpenWaitlist }) {
  return (
    <div className={styles.hero}>
      <div className={styles.container}>
        <Header />
        <main className={styles.stage}>
          <NoiseCanvas />
          <div className={styles.overlay}>
            <div className={styles.texture}>
              {TEXTURE_LINES.map((line, i) => (
                <Fragment key={i}>
                  {line}
                  <br />
                </Fragment>
              ))}
            </div>
            <InfoPanel onOpenWaitlist={onOpenWaitlist} />
          </div>
        </main>
      </div>
    </div>
  );
}
